// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  // ==========================================
  // MÓDULO 1: CART ATTRIBUTES (CHECKOUT ESTÁNDAR)
  // ==========================================
  (function initCartAttributes() {
    "use strict";

    // Función para obtener el valor de un parámetro URL
    function getURLParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";
    }

    // Función para obtener el valor de una cookie
    function getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    }

    // Función para obtener el último fragmento después del punto de _gcl_aw
    function getGclidFromCookie() {
      const gclAw = getCookie("_gcl_aw");
      if (gclAw) {
        const parts = gclAw.split(".");
        return parts[parts.length - 1] || "";
      }
      return "";
    }

    // Función para recopilar datos de tracking
    function getTrackingData() {
      return {
        source: getURLParameter("neose"),
        medium: getURLParameter("neomm"),
        campaign: getURLParameter("neocn"),
        term: getURLParameter("neotm"),
        content: getURLParameter("neoct"),
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
        ttp: getCookie("_ttp"),
        ttclid: getCookie("ttclid"),
        gclid: getGclidFromCookie(),
      };
    }

    // Verificar si tracking_updated está en false o no existe en sessionStorage
    const trackingUpdated = sessionStorage.getItem("tracking_updated");

    if (trackingUpdated !== "true") {
      // Agregar delay de 2 segundos para garantizar que otros procesos del tema se ejecuten primero
      setTimeout(function () {
        // Recopilar todos los valores
        const trackingData = getTrackingData();

        // Construir el objeto attributes solo con valores existentes
        // Los parámetros UTM van con primera letra mayúscula
        const attributes = {};

        // Agregar atributo de verificación de Neosocios SIEMPRE
        attributes.Neosocios = "true";

        // Agregar demás atributos solo si existen
        if (trackingData.source) attributes.Source = trackingData.source;
        if (trackingData.medium) attributes.Medium = trackingData.medium;
        if (trackingData.campaign) attributes.Campaign = trackingData.campaign;
        if (trackingData.term) attributes.Term = trackingData.term;
        if (trackingData.content) attributes.Content = trackingData.content;
        if (trackingData.fbp) attributes.fbp = trackingData.fbp;
        if (trackingData.fbc) attributes.fbc = trackingData.fbc;
        if (trackingData.ttp) attributes.ttp = trackingData.ttp;
        if (trackingData.ttclid) attributes.ttclid = trackingData.ttclid;
        if (trackingData.gclid) attributes.gclid = trackingData.gclid;

        // Actualizar los note_attributes del carrito usando la API de Shopify
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ attributes }),
        })
          .then((response) => {
            if (response.ok) {
              console.log("Neosocios: Cart attributes updated successfully");
              // Establecer tracking_updated en true en sessionStorage
              sessionStorage.setItem("tracking_updated", "true");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Neosocios: Updated cart ", data);
          })
          .catch((error) => {
            console.error("Neosocios: Error updating cart attributes:", error);
          });
      }, 2000); // Delay de 2 segundos
    }
  })();

  // ==========================================
  // MÓDULO 2: RELEASIT FORM POPULATION
  // ==========================================
  (function initReleasitPopulation() {
    "use strict";

    // Función para poblar los campos del formulario Releasit
    function populateReleasitFields() {
      // Obtener datos de tracking de forma independiente
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get("neose") || "";
      const medium = urlParams.get("neomm") || "";
      const campaign = urlParams.get("neocn") || "";
      const term = urlParams.get("neotm") || "";
      const content = urlParams.get("neoct") || "";

      // Función local para cookies
      function getDirectCookie(name) {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? match[2] : "";
      }

      const fbp = getDirectCookie("_fbp");
      const fbc = getDirectCookie("_fbc");
      const ttp = getDirectCookie("_ttp");
      const ttclid = getDirectCookie("ttclid");

      // Obtener gclid localmente
      const gclAw = getDirectCookie("_gcl_aw");
      let gclid = "";
      if (gclAw) {
        const parts = gclAw.split(".");
        gclid = parts[parts.length - 1] || "";
      }

      // Configuración de campos: selector -> valor
      const fieldMappings = {
        Neosocios: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Neosocios"]) input',
          value: "true", // SIEMPRE true para verificación
        },
        Source: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Source"]) input',
          value: source,
        },
        Medium: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Medium"]) input',
          value: medium,
        },
        Campaign: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Campaign"]) input',
          value: campaign,
        },
        Term: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Term"]) input',
          value: term,
        },
        Content: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_Content"]) input',
          value: content,
        },
        fbc: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_fbc"]) input',
          value: fbc,
        },
        fbp: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_fbp"]) input',
          value: fbp,
        },
        ttp: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_ttp"]) input',
          value: ttp,
        },
        ttclid: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_ttclid"]) input',
          value: ttclid,
        },
        gclid: {
          selector:
            '._rsi-modal-fields-item:has(input[name="additionals_text_input_gclid"]) input',
          value: gclid,
        },
      };

      // Aplicar delay de 3 segundos antes de poblar campos
      setTimeout(() => {
        const fieldsSet = [];

        // Poblar cada campo - el campo Neosocios SIEMPRE se incluirá
        Object.entries(fieldMappings).forEach(([fieldName, config]) => {
          // Para el campo Neosocios, siempre intentar setearlo
          // Para otros campos, solo si tienen valor
          if (fieldName === "Neosocios" || config.value) {
            const input = document.querySelector(config.selector);
            if (input) {
              input.value = config.value;
              fieldsSet.push(`${fieldName}: ${config.value}`);

              // Disparar eventos para asegurar que Releasit detecte los cambios
              input.dispatchEvent(new Event("input", { bubbles: true }));
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        });

        // Log final con campos y valores establecidos
        if (fieldsSet.length > 0) {
          console.log(
            `Neosocios: Releasit form populated - ${
              fieldsSet.length
            } fields set: ${fieldsSet.join(", ")}`
          );
        } else {
          console.log(
            "Neosocios: Releasit form detected but no fields could be populated"
          );
        }
      }, 3000); // Delay de 3 segundos
    }

    // Función para esperar a que aparezca el formulario Releasit usando MutationObserver
    function waitForReleasitForm() {
      // Verificar si el formulario ya existe
      const existingForm = document.querySelector("._rsi-modal-fields-item");
      if (existingForm) {
        console.log("Neosocios: Releasit form detected");
        populateReleasitFields();
        return;
      }

      // Crear MutationObserver para detectar cuando aparece el formulario
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            // Verificar si el nodo agregado contiene elementos del formulario Releasit
            if (node.nodeType === Node.ELEMENT_NODE) {
              const releasitForm = node.querySelector
                ? node.querySelector("._rsi-modal-fields-item")
                : null;
              const isReleasitForm =
                node.matches && node.matches("._rsi-modal-fields-item");

              if (releasitForm || isReleasitForm) {
                console.log("Neosocios: Releasit form detected");
                populateReleasitFields();
                observer.disconnect(); // Desconectar observer después de encontrar el formulario
              }
            }
          });
        });
      });

      // Configurar e iniciar el observer
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    // Iniciar la función de espera del formulario
    waitForReleasitForm();
  })();
});